import { Home, Activity, User, Send } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";

export const BottomNav = () => {
  const loc = useLocation();
  const nav = useNavigate();
  const { resetDraft } = useApp();

  const showNav = ["/demo", "/activity", "/profile"].includes(loc.pathname);
  if (!showNav) return null;

  const startPay = () => {
    resetDraft();
    nav("/send/recipient");
  };

  const navItems = [
    { to: "/demo", icon: Home, label: "Home", testId: "nav-home" },
    { to: "/activity", icon: Activity, label: "Activity", testId: "nav-activity" },
    { to: "/send/recipient", icon: Send, label: "Pay", testId: "nav-pay", onClick: startPay },
    { to: "/profile", icon: User, label: "Account", testId: "nav-profile" },
  ];

  return (
    <div
      data-testid="bottom-nav"
      className="absolute bottom-0 left-0 right-0 h-20 bg-white/85 dark:bg-slate-900/85 backdrop-blur-xl border-t border-gray-100 dark:border-white/10 flex justify-around items-center px-4 z-40"
    >
      {navItems.map(({ to, icon: Icon, label, testId, onClick }) => {
        const active = loc.pathname === to || (to === "/send/recipient" && loc.pathname.startsWith("/send"));
        return (
          <NavButton
            key={label}
            active={active}
            icon={Icon}
            label={label}
            testId={testId}
            onClick={onClick || (() => nav(to))}
          />
        );
      })}
    </div>
  );
};

const NavButton = ({ active, icon: Icon, label, testId, onClick }) => (
  <button
    data-testid={testId}
    onClick={onClick}
    className="flex flex-col items-center gap-1 transition-colors group flex-1"
  >
    <Icon
      className={
        "w-6 h-6 transition-colors " +
        (active ? "text-black dark:text-emerald-500" : "text-gray-400 group-hover:text-gray-700 dark:group-hover:text-gray-200")
      }
      strokeWidth={active ? 2.3 : 1.8}
    />
    <span
      className={
        "text-[10px] font-semibold tracking-wide transition-colors " +
        (active ? "text-black dark:text-white" : "text-gray-400")
      }
    >
      {label}
    </span>
  </button>
);

export default BottomNav;
